import { render, staticRenderFns } from "./TopNavBar.vue?vue&type=template&id=a5784f52&scoped=true&"
import script from "./TopNavBar.vue?vue&type=script&lang=js&"
export * from "./TopNavBar.vue?vue&type=script&lang=js&"
import style0 from "./TopNavBar.vue?vue&type=style&index=0&id=a5784f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5784f52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
installComponents(component, {VAppBar})
